import styled from '@emotion/styled';
import { calculateWidth, CarouselItemProps } from './helpers';
import { SlideBtn } from 'ds/components/carousels/styled';


export const CarouselItem = styled.div<CarouselItemProps>`
  padding: 4px;
  width: ${({ autoWidth = false }) => autoWidth ? 'auto' : calculateWidth};
`;

export const Chunk = styled.div`
  display: flex;
`;

export const CarouselWrapper = styled.div`
  width: 100%;
  position: relative;
  &:hover {
    [dir='prev'],
    [dir='next'] {
      opacity: 1;
    }
  }
`;

// todo: check if we can remove "top: 82px" since it's quite weird to use the same value for all (e.g. what if a card height is less 82px ?)
const PositionedSlidebtn = styled(SlideBtn)`
  top: 82px;
  transition: opacity .2s ease;
  opacity: 0;
`;

export const LeftBtn = styled(PositionedSlidebtn)<{ hasArrows: boolean }>`
  ${({ theme }) => `
    && {
      ${theme.isRTL ? 'right' : 'left'}: -${theme.spacing(1)};
    }
  `};
`;

export const RightBtn = styled(PositionedSlidebtn)<{ hasArrows: boolean }>`
  ${({ theme }) => `
    && {
      ${theme.isRTL ? 'left' : 'right'}: -${theme.spacing(1)};
    }
  `};
`;
